import Vue from 'vue'

const USER = {
	SIGNIN: (email, password) => {
		return Vue.$api.post('/signin', { email, password })
	},
	UPDATE: (id, email, firstname, lastname) => {
		return Vue.$api.patch('/users/' + id, { email, firstname, lastname })
	},
	PASSWORD: (id, password) => {
		return Vue.$api.patch('/users/' + id + '/password', { password })
	},

	AVATAR: (id, file) => {
		return Vue.$api.post(
			'/users/' + id + '/avatar',
			{ file },
			{
				headers: {
					'content-type': 'multipart/form-data',
				},
			},
		)
	},
}

export default USER
